import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { makeAuthService } from 'src/data/services/auth/auth-service-factory';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private authService = makeAuthService();

  async canActivate(): Promise<boolean> {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    try {
      await this.authService.login();
      return this.authService.isAuthenticated();
    } catch {
      return false;
    }
  }
}
